import { render, staticRenderFns } from "./DebirsGroup.vue?vue&type=template&id=7f42c1fc&scoped=true&"
import script from "./DebirsGroup.vue?vue&type=script&lang=js&"
export * from "./DebirsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f42c1fc",
  null
  
)

export default component.exports